import { observer } from 'mobx-react-lite';
import { Base } from 'zf-web-components';
import { App } from 'config';
import { useApp } from '@components';
import styles from './index.module.less';
import { ShoteyesPrivacyPage } from './shoteyesPricy';
import type { ReactElement } from 'react';

function PrivacyPage(): ReactElement {
  const { app } = useApp();
  // 巡店隐私政策
  if (app === App.SHOTEYES) {
    return <ShoteyesPrivacyPage />;
  }

  return (
    <Base.Layout className={styles.privacyContainer}>
      <h2 style={{ textAlign: 'center', marginTop: '40px' }}>{'隐私声明'}</h2>
      <hr className={styles.divider} />

      <div className={styles.textIndent}>
        <div>{'Marketing BI（以及下文提到的"我们"、"我们的"）是由主体公司字符科技（大连）有限公司提供的网络产品。'}</div>
        <div>{'产品名称：Marketing BI'}</div>
        <div>{'产品类别：网页应用程序'}</div>
        <div>{'如果您决定使用我们产品提供的服务，本协议用于告知我们对于用户的隐私如何收集、使用和披露。'}</div>
        <div>
          <b>
            {'如果您选择使用我们提供的服务，则表示您同意收集和使用与此政策相关的信息。我们收集的个人信息用于提供和改进服务。除非本隐私政策中另有说明，否则我们不会与任何人一起使用或分享您的信息。'}
          </b>
        </div>
        <div>{'除非本隐私政策另有规定，否则本隐私政策中使用的术语与我们的条款和条件具有相同的含义，可在Marketing BI中访问。'}</div>
      </div>

      <h3 className={styles.titleContainer}>{'1、收集信息'}</h3>
      <div>
        <div className={styles.textIndent}>{'我们收集您提供给我们的部分或全部信息，以及您使用网站和应用程序的数据，但我们将主要使用收集的数据为您提供满意的服务，并提高您的使用体验。'}</div>
      </div>

      <h4 className={styles.titleContainer}>{'1.1、设备和技术信息的收集'}</h4>
      <div className={styles.textIndent}>
        <div>{'我们可能会收集您使用我们的应用程序所需的数据，我们可以维护和分析应用程序的功能。'}</div>
        <div>
          {'我们自动获得有关您的设备的某些信息，包括IP地址，国家代码，时区会话开始/停止时间；IDFVs，语言；浏览器插件类型和版本；平台，SDK版本，时间戳。虽然这些信息（如IDFV、IP地址）可能唯一地标识您的设备，但此信息并没有亲自识别您。某些立法（如美国）可以将您的设备唯一标识为个人信息的信息处理。'}
        </div>
      </div>

      <h4 className={styles.titleContainer}>{'1.2、常规个人信息收集'}</h4>
      <div>
        <div className={styles.textIndent}>
          {'在使用我们的服务时，我们可能会要求您向我们提供可用于联系或识别您的某些个人身份信息（"个人数据"），个人身份信息可能包括但不限于：'}
        </div>
        <ul>
          <li>{'账号名、登录密码'}</li>
        </ul>
      </div>

      <h3 className={styles.titleContainer}>{'2、如何使用收集的信息'}</h3>
      <div>
        <div className={styles.textIndent}>{'Marketing BI将收集的数据用于以下其中的部分或全部目的：'}</div>
        <ul>
          <li>{'提供和维护服务'}</li>
          <li>{'通知您有关我们服务的更改'}</li>
          <li>{'允许您在选择时参与我们服务的互动功能'}</li>
          <li>{'为客户提供关怀和支持'}</li>
          <li>{'提供分析或有价值的信息，以便我们改进服务'}</li>
          <li>{'监控服务的使用情况'}</li>
          <li>
            {'检测，预防和解决技术问题当您通过移动设备访问服务时，我们可能会自动收集某些信息，包括但不限于您使用的移动设备类型，移动设备唯一ID，移动设备的IP地址，移动设备操作系统，您使用的移动互联网浏览器的类型，唯一的设备标识符和其他诊断数据（"使用数据"）'}
          </li>
        </ul>
      </div>

      <h3 className={styles.titleContainer}>{'3、信息存储'}</h3>

      <h4 className={styles.titleContainer}>{'3.1、数据安全'}</h4>
      <div className={styles.textIndent}>
        <div>{'数据的安全性对我们很重要，但请记住，没有任何安全措施是完美的或不可渗透的。虽然我们努力使用商业上可接受的方式来保护您的个人数据，但我们无法保证其绝对的安全性。'}</div>
      </div>

      <h4 className={styles.titleContainer}>{'3.2、数据传输'}</h4>
      <div className={styles.textIndent}>
        <div>{'您的信息（包括个人数据）可能会被转移到您所在州，省，国家或其他政府管辖范围之外的计算机上，并且这些计算机的数据保护法可能与您所在司法管辖区的数据保护法不同。'}</div>
        <div>{'如果您位于中国境外并选择向我们提供信息，请注意我们将数据（包括个人数据）传输到中国并在中国处理。'}</div>
        <div>{'您同意本隐私政策，然后提交此类信息即表示您同意该转让。'}</div>
      </div>

      <h4 className={styles.titleContainer}>{'3.3、数据披露'}</h4>
      <div>
        <div className={styles.textIndent}>{'Marketing BI可能会真诚地披露您的个人资料，相信此类行为是必要的：'}</div>
        <ul>
          <li>{'履行法律义务'}</li>
          <li>{'保护和捍卫本软件的权利或财产'}</li>
          <li>{'防止或调查与服务相关的可能的不当行为'}</li>
          <li>{'保护服务或公众用户的人身安全'}</li>
          <li>{'防止法律责任'}</li>
        </ul>
      </div>

      <h4 className={styles.titleContainer}>{'3.4、服务供应商'}</h4>
      <div>
        <div className={styles.textIndent}>
          {'我们可能雇用第三方（公司或个人）来促进我们的服务（"服务提供商"）。第三方代表我们提供服务，执行相关服务或协助我们分析服务的使用方式。第三方只能代表我们访问您的个人数据以执行这些任务，并且有义务不将其用于任何其他目的。'}
        </div>
      </div>

      <h4 className={styles.titleContainer}>{'3.5、链接到其它网站'}</h4>
      <div>
        <div className={styles.textIndent}>
          {'我们的服务可能包含指向非我们运营的其他网站的链接。如果您点击第三方链接，您将被引导至该第三方的网站。我们强烈建议您查看您访问的每个站点的隐私政策。我们无法控制任何第三方网站或服务的内容，隐私政策或做法，也不承担任何责任。'}
        </div>
      </div>

      <h3 className={styles.titleContainer}>{'4、删除信息'}</h3>
      <div>
        <div className={styles.textIndent}>
          {'当不再需要信息时，我们将使用合理的措施删除它，以保护信息不被未经授权的访问或使用。用户上传的内容如果涉嫌黄色、暴力不受欢迎内容我们将有权进行删除。'}
        </div>
      </div>

      <h3 className={styles.titleContainer}>{'5、保护信息'}</h3>
      <div>
        <div className={styles.textIndent}>
          {'我们已经实施了合理的安全措施，以保障收集信息的机密性、安全性和完整性，并防止未经授权的访问和使用违反本隐私政策的信息。虽然我们采取合理的努力，以保障您的信息在我们维护时依然安全，但请注意，没有任何安全措施是绝对安全的。'}
        </div>
      </div>

      <h3 className={styles.titleContainer}>{'6、Cookie技术'}</h3>
      <div>
        <div className={styles.textIndent}>{'我们使用Cookie和类似的跟踪技术来跟踪我们服务上的活动并保留某些信息。'}</div>
        <div className={styles.textIndent}>
          {'Cookie是包含少量数据的文件，可能包含匿名唯一标识符。Cookie会从网站发送到您的浏览器并存储在您的设备上。还使用其他跟踪技术比如信标，标签和脚本等，用于收集和跟踪信息以及改进和分析我们的服务。'}
        </div>
        <div className={styles.textIndent}>{'您可以指示您的浏览器拒绝所有Cookie或指示何时发送Cookie。但是，如果您不接受Cookie，您可能无法使用我们服务的某些部分。'}</div>
        <div className={styles.textIndent}>{'我们使用的Cookie示例：'}</div>
        <ul>
          <li>{'会话Cookie。我们使用Session Cookie来运营我们的服务。'}</li>
          <li>{'偏好Cookie。我们使用首选项Cookie来记住您的偏好和各种设置。'}</li>
          <li>{'安全Cookie。出于安全考虑，我们使用安全Cookie。'}</li>
        </ul>
      </div>

      <h3 className={styles.titleContainer}>{'7、退出'}</h3>
      <div>
        <div className={styles.textIndent}>{'根据本隐私政策，您可以从您的每台设备上停止使用本网站，从而永远自由地选择不参与将来在软件内收集您的个人信息。'}</div>
      </div>

      <h3 className={styles.titleContainer}>{'8、个人信息主体注销账号'}</h3>
      <div className={styles.textIndent}>
        <div>{'您可以随时注销您所注册的账号，注销账号的方式为：通过设置中的账号选项进行自助注销，或联系企业管理人员，我们进行即时注销处理。'}</div>
        <div>{'当您完成账号的注销后，我们将停止为您提供相应的产品和服务，并删除相关个人信息或进行匿名化处理，因法律法规另有规定而需要留存个人信息的除外（但不会再将相关信息用于日常业务活动）。'}</div>
      </div>

      <h3 className={styles.titleContainer}>{'9、运营者基本信息'}</h3>
      <div className={styles.textIndent}>
        <div>{'单位名称：字符科技（大连）有限公司'}</div>
        <div>{'注册地址：大连市甘井子区七贤园13号3单元4层1号'}</div>
        <div>{'办公地址：大连市高新园区腾讯大厦601'}</div>
        <div>{'信息保护负责人联系电话：+86 134 7878 5024'}</div>
      </div>

      <h3 className={styles.titleContainer}>{'10、支持'}</h3>
      <div>
        <div className={styles.textIndent}>{'如果您对本隐私政策有任何疑问，请联系我们：'}</div>
        <div className={styles.titleContainer}>{'邮件：member@alphabets.cn'}</div>
        <div className={styles.titleContainer}>{'官网：https://www.alphabets.cn'}</div>
        <div className={styles.titleContainer}>{'电话：+86 186 4262 7048 (Mrs.邵)'}</div>
        <div style={{ padding: '0 20px', textIndent: '2.3em' }}>{'+86 134 7878 5024 (Mr.沈)'}</div>
      </div>

      <h3 className={styles.titleContainer}>{'11、对此隐私策略的更改'}</h3>
      <div className={styles.textIndent}>
        <div>{'我们可能会不时更新我们的隐私政策。我们将通过在此页面上发布新的隐私政策来通知您任何更改。'}</div>
        <div>{'建议您定期查看本隐私政策以了解任何变更。本隐私政策的更改在此页面上发布时生效。'}</div>
      </div>

      <div className={styles.textIndent} style={{ marginTop: '20px', marginBottom: '40px' }}>
        <div>{'发布时间：2025年4月17日'}</div>
        <div>{'生效时间：2025年4月17日'}</div>
        <div>{'更新时间：2025年4月17日'}</div>
      </div>
    </Base.Layout>
  );
}

export default observer(PrivacyPage);
